/** Docs (UA): https://prostopay.atlassian.net/wiki/spaces/SW/pages/1902772238 — localStorage стратегія */

import {
    LOCAL_STORAGE_KEYS,
    LOCAL_STORAGE_DEFAULTS,
    LocalStorageKeyName,
    LocalStorageValueMap,
} from './local-storage.data';

class LocalStorageService {
    private getStorageKey(name: LocalStorageKeyName): string {
        return LOCAL_STORAGE_KEYS[name];
    }

    setItem<K extends LocalStorageKeyName>(key: K, value: LocalStorageValueMap[K]): void {
        try {
            const storageKey = this.getStorageKey(key);
            const serialized = typeof value === 'string' ? value : JSON.stringify(value);
            localStorage.setItem(storageKey, serialized);
        } catch (error) {
            console.error({ module: 'shared', action: 'localStorage.setItem', key }, error);
        }
    }

    getItem<K extends LocalStorageKeyName>(key: K): LocalStorageValueMap[K] {
        try {
            const storageKey = this.getStorageKey(key);
            const item = localStorage.getItem(storageKey);
            if (item === null) {
                return LOCAL_STORAGE_DEFAULTS[key];
            }
            if (typeof LOCAL_STORAGE_DEFAULTS[key] === 'string') {
                return item as LocalStorageValueMap[K];
            }
            return JSON.parse(item);
        } catch (error) {
            console.error({ module: 'shared', action: 'localStorage.getItem', key }, error);
            return LOCAL_STORAGE_DEFAULTS[key];
        }
    }

    removeItem(key: LocalStorageKeyName): void {
        localStorage.removeItem(this.getStorageKey(key));
    }

    clear(): void {
        localStorage.clear();
    }
}

export const localStorageService = new LocalStorageService();
